import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'widgetImage',
    standalone: false
})
export class WidgetImagePipe implements PipeTransform {

  transform(images: string[], index: number): string {
    if (!images?.length) {
      return;
    }

    if (typeof images[index] !== 'undefined') {
      return images[index];
    }

    return images[0];
  }
}
